import { FEATURE_NAME } from './consts';

export const DELETE_BRAND = `${FEATURE_NAME}/DELETE_BRAND`;

export const RETRY_FETCH = `${FEATURE_NAME}/RETRY_FETCH`;
